import { render, staticRenderFns } from "./VuesticIconVue.vue?vue&type=template&id=4cd87158"
import script from "./VuesticIconVue.vue?vue&type=script&lang=js"
export * from "./VuesticIconVue.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconVue.vue?vue&type=style&index=0&id=4cd87158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports